module.exports = __webpack_public_path__ + "static/media/perspectico.5d6509b6.png";